import { render, staticRenderFns } from "./chosen-med-type.vue?vue&type=template&id=fd7ec476&scoped=true"
import script from "./chosen-med-type.vue?vue&type=script&lang=js"
export * from "./chosen-med-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7ec476",
  null
  
)

export default component.exports